module.exports = __webpack_public_path__ + "static/media/logo-vsalm.409752b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Logo/assets/logo-vsalm.png
// module id = 913
// module chunks = 40